<template>
  <div class="main">
    <div v-if="fromXB" class="nav">
      <div class="nav-btn left" @click="goBack">
        <img src="@/assets/groupBuy/back-black.png" alt="" class="back" />
      </div>
      <div class="nav-title">拼团说明</div>
      <div class="nav-btn"></div>
    </div>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import { getQuery } from "./utils";

export default {
  data() {
    return {
      content: null,
      fromXB: false,
    };
  },
  mounted() {
    let activity_id = getQuery("id", location.href);
    this.fromXB = !!getQuery("xb", location.href);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    this.$api
      .get("activity/index/get/content", {
        activity_id,
      })
      .then((res) => {
        this.content = res.content;
      });
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .nav {
    display: flex;
    align-items: stretch;
    height: 4rem;
    background: #fff;
    padding-top: var(--status-height);

    &-btn {
      flex: 0 0 4em;
      overflow: visible;
      display: flex;
      align-items: center;
      margin: 0 1.2rem;

      &.right {
        justify-content: right;
      }
    }

    &-title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      font-size: 1.8rem;
      font-weight: 500;
    }

    .back {
      width: 1.8rem;
      height: 1.8rem;
    }

    &-placeholder {
      height: calc(4rem + var(--status-height));
    }
  }

  .content {
    flex: 1;
    padding: 1.2rem 1.6rem 0;
    font-size: 1.5rem;
    line-height: 2.4rem;
    overflow: auto;

    /deep/ img {
      max-width: 100%;
    }
  }
}
</style>